/**
 * Route-level permission guards — all cleared for demo/simulation mode.
 * Every admin user can access every section.
 */
export const GUARDED_ROUTE_PREFIXES: [string, string][] = [];
